// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function QuickViewButton(Props) {
  var colorOpt = Props.color;
  var className = Props.className;
  var onClick = Props.onClick;
  var children = Props.children;
  var blockOpt = Props.block;
  var flexOpt = Props.flex;
  var style = Props.style;
  var hasTextOpt = Props.hasText;
  var disabled = Props.disabled;
  var href = Props.href;
  var openLinkInNewTab = Props.openLinkInNewTab;
  var fwdRef = Props.fwdRef;
  var title = Props.title;
  var dataId = Props.dataId;
  var dataTestId = Props.dataTestId;
  var dataCount = Props.dataCount;
  var ariaLive = Props.ariaLive;
  var tabIndex = Props.tabIndex;
  var color = colorOpt !== undefined ? colorOpt : /* Unstyled */3;
  var block = blockOpt !== undefined ? blockOpt : false;
  var flex = flexOpt !== undefined ? flexOpt : false;
  var hasText = hasTextOpt !== undefined ? hasTextOpt : false;
  var display = flex ? "flex" : "block";
  var display$1 = block ? display : "inline-" + display;
  var display$2 = hasText ? display$1 : Cn.make([display$1, "leading-0"]);
  var tmp;
  switch (color) {
    case /* Dark */0:
      tmp = CSS$Showside.prefix("bg-black bg-opacity-35 text-white dark-hover darker-active");
      break;
    case /* Light */1:
      tmp = CSS$Showside.prefix("text-black bg-white dark-hover darker-active");
      break;
    case /* Clear */2:
      tmp = CSS$Showside.prefix("text-white bg-transparent drop-shadow-sm filter");
      break;
    case /* Unstyled */3:
      tmp = "";
      break;
  }
  var className$1 = Cn.make([CSS$Showside.prefix(display$2), CSS$Showside.prefix("cursor-pointer select-none"), tmp, CSS$Showside.prefix("font-button"), Belt_Option.getWithDefault(className, "")]);
  var disabled$1 = Belt_Option.getWithDefault(disabled, false);
  var href$1 = disabled$1 ? undefined : href;
  var onClick$1 = disabled$1 ? undefined : onClick;
  var tmp$1;
  if (href$1 !== undefined) {
    var tmp$2 = {
      children: children,
      href: href$1,
      unstyled: true,
      className: Cn.make([CSS$Showside.prefix("block no-underline"), className$1]),
      role: "button"
    };
    if (title !== undefined) {
      tmp$2.title = Caml_option.valFromOption(title);
    }
    if (fwdRef !== undefined) {
      tmp$2.fwdRef = Caml_option.valFromOption(fwdRef);
    }
    if (style !== undefined) {
      tmp$2.style = Caml_option.valFromOption(style);
    }
    if (openLinkInNewTab !== undefined) {
      tmp$2.openLinkInNewTab = Caml_option.valFromOption(openLinkInNewTab);
    }
    if (dataTestId !== undefined) {
      tmp$2.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    if (disabled !== undefined) {
      tmp$2.dataDisabled = Caml_option.valFromOption(disabled);
    }
    if (onClick$1 !== undefined) {
      tmp$2.onClick = Caml_option.valFromOption(onClick$1);
    }
    if (tabIndex !== undefined) {
      tmp$2.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    tmp$1 = React.createElement(Link$Showside.make, tmp$2);
  } else {
    var tmp$3 = {
      className: className$1
    };
    if (fwdRef !== undefined) {
      tmp$3.ref = Caml_option.valFromOption(fwdRef);
    }
    var tmp$4 = onClick$1 !== undefined ? "button" : undefined;
    if (tmp$4 !== undefined) {
      tmp$3.role = Caml_option.valFromOption(tmp$4);
    }
    if (style !== undefined) {
      tmp$3.style = Caml_option.valFromOption(style);
    }
    var tmp$5 = tabIndex !== undefined ? tabIndex : onClick$1 !== undefined ? 0 : undefined;
    if (tmp$5 !== undefined) {
      tmp$3.tabIndex = Caml_option.valFromOption(tmp$5);
    }
    if (title !== undefined) {
      tmp$3.title = Caml_option.valFromOption(title);
    }
    if (onClick$1 !== undefined) {
      tmp$3.onClick = Caml_option.valFromOption(onClick$1);
    }
    tmp$1 = React.createElement("div", tmp$3, children);
  }
  var tmp$6 = {
    children: tmp$1
  };
  if (disabled !== undefined) {
    tmp$6.dataDisabled = disabled;
  }
  if (dataTestId !== undefined) {
    tmp$6.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp$6.dataId = dataId;
  }
  if (dataCount !== undefined) {
    tmp$6.dataCount = dataCount;
  }
  if (ariaLive !== undefined) {
    tmp$6.ariaLive = ariaLive;
  }
  return React.createElement(DataAttribute$Showside.make, tmp$6);
}
QuickViewButton.displayName = "QuickViewButton";
var make = QuickViewButton;
export { make };
/* react Not a pure module */